import React, { useEffect, useState } from "react";
import { X, Gift } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

export default function ReferralPopup() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    if (loc.pathname.startsWith("/booking")) return; // don't interrupt the wizard
    const dismissed = sessionStorage.getItem("lume_referral_dismissed");
    if (dismissed) return;
    const t = setTimeout(() => setOpen(true), 8000);
    return () => clearTimeout(t);
  }, [loc.pathname]);

  const close = () => {
    setOpen(false);
    sessionStorage.setItem("lume_referral_dismissed", "1");
  };

  const refer = () => {
    close();
    nav("/contact?subject=referral");
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 fade-up" style={{ background: "rgba(0,0,0,0.72)" }} onClick={close}>
      <div
        className="max-w-md w-full rounded-2xl overflow-hidden relative"
        style={{ background: "linear-gradient(160deg, #131519 0%, #0B0C0E 100%)", border: "1px solid rgba(212,175,55,0.35)", boxShadow: "0 30px 90px -20px rgba(212,175,55,0.25)" }}
        onClick={(e) => e.stopPropagation()}
        data-testid="referral-popup"
      >
        <button onClick={close} className="absolute top-4 right-4 text-slate-400 hover:text-white" data-testid="referral-close" aria-label="Close">
          <X size={18} />
        </button>
        <div className="p-8 sm:p-10">
          <div className="w-12 h-12 rounded-full flex items-center justify-center mb-6" style={{ background: "rgba(212,175,55,0.12)", border: "1px solid rgba(212,175,55,0.35)" }}>
            <Gift className="text-[color:var(--lume-gold)]" size={20} />
          </div>
          <div className="eyebrow mb-3">Referral Program</div>
          <h3 className="font-serif text-3xl text-white leading-tight">Refer Someone.<br /><span className="italic text-[color:var(--lume-gold-light)]">Save 10%.</span></h3>
          <p className="text-slate-400 mt-5 text-sm leading-relaxed">
            Refer a friend or someone you know to Lume Enterprise. Once they complete their first ride, you'll receive 10% off.
          </p>
          <div className="my-6 gold-hairline" />
          <p className="font-serif text-xl text-[color:var(--lume-gold-light)]">Earn 10% off for every successful referral.</p>
          <button onClick={refer} className="btn-gold w-full mt-6" data-testid="referral-cta">Refer Someone</button>
        </div>
      </div>
    </div>
  );
}
